// extracted by mini-css-extract-plugin
export default {"Settings":"Settings_Settings__gsHY+","shad":"Settings_shad__SNxKp","line":"Settings_line__HC7H1"};